// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"1dec5a4f","286":"177c5239","411":"f8c32be3","472":"b5a5b9c9","488":"a1e8d1e2","596":"3d496c9f","771":"f015043b","945":"0a8266a4","988":"90499aca"}[chunkId] + ".chunk.js";
};